import { useState } from 'react';
import styled from 'styled-components';

import imagemDer from '../../assets/imagensDERs/sisafDerModuloFornecedor.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.15rem;
  text-align: justify;
  padding: 5px;

  ul {
    margin-bottom: 15px;
  }
`;

const Definicao = styled.div`
  margin-bottom: 20px;
`;

const AbasContainer = styled.div`
  display: flex;
  border-bottom: 2px solid #b0c4de;
  margin-bottom: 15px;
`;

const Aba = styled.div<{ active: boolean }>`
  padding: 10px 20px;
  cursor: pointer;
  font-weight: ${({ active }) => (active ? 'bold' : 'normal')};
  background-color: ${({ active }) => (active ? '#869ddb83' : 'transparent')};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  &:hover {
    background-color: #b0c4de;
  }
`;

const ImagemDer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid lightgray;
  background-color: lightgray;
  margin-bottom: 25px;

  img {
    height: 30vh;
    border-radius: 10px;
    width: auto;

    transition: transform 0.3s ease-in-out;

    &:hover {
      /* transform: scale(1.5); */
    }
  }
`;

const AbaDefinicoes = () => {
  return (
    <>
      <ul>
        <li>
          <b>Tickets</b>
        </li>
        <ul>
          <li>
            Tickets são registros na entidade TAB_TICKETS, utilizados para
            coletar sugestões de usuários sobre novas funcionalidades, ajustes
            ou correções de falhas e bugs no sistema. Cada ticket pode ser
            criado por qualquer usuário, mas apenas o autor pode editá-lo ou
            excluí-lo. Esses registros também permitem que a equipe de
            desenvolvimento forneça retornos diretamente no sistema, promovendo
            um canal de comunicação claro e eficiente para a melhoria contínua
            do SisDAF.
          </li>
        </ul>

        <li>
          <b>Tasks</b>
        </li>
        <ul>
          <li>
            As Tasks representam atividades específicas a serem realizadas pela
            equipe de desenvolvimento, armazenadas na entidade TB_TASKS. Elas
            incluem tanto tarefas de desenvolvimento (adaptativas e evolutivas)
            quanto atividades relacionadas à documentação. Cada tarefa possui
            informações como status (pendente ou realizada), descrição, datas de
            entrada e finalização, além do módulo ou submódulo associado. Esse
            gerenciamento estruturado das tasks permite priorizar e acompanhar o
            progresso das atividades essenciais para o sistema.
          </li>
        </ul>

        <li>
          <b>Documentos</b>
        </li>
        <ul>
          <li>
            Os Documentos são materiais técnicos organizados na entidade
            TB_DOCUMENTOS, englobando relatórios, manuais, planilhas e outros
            arquivos relevantes ao sistema. Esses registros incluem dados como
            título, resumo, tipo, extensão e links para acesso, assegurando que
            toda a documentação do SisDAF esteja centralizada em um repositório
            único. Apenas a equipe de desenvolvimento tem permissão para
            gerenciar os documentos, garantindo a integridade e a organização
            das informações críticas para o sistema.
          </li>
        </ul>

        <li>
          <b>Notas de Versão</b>
        </li>
        <ul>
          <li>
            Notas de Versão no SisAF são registros estruturados na entidade
            TB_NOTA_VERSAO_SISAF, que documentam as versões do sistema,
            detalhando suas características e histórico de mudanças. Esses
            registros são fundamentais para manter um histórico centralizado e
            organizado das atualizações do sistema.
          </li>
        </ul>
      </ul>
    </>
  );
};

const Entidades = () => {
  return (
    <>
      <ImagemDer>
        <img src={imagemDer}></img>
      </ImagemDer>

      <b>Entidades</b>
      <ul>
        <li>
          <b>TB_FORNECEDOR</b>
        </li>
        <ul>
          <li>
            Entidade que concentra as informações de identificação do
            fornecedor.
          </li>
        </ul>

        <li>
          <b>TB_FORNECEDOR_REPRESENTANTE</b>
        </li>
        <ul>
          <li>
            Entidade que identifica os representantes técnicos e comerciais do
            fornecedor: nome, cargo e telefone.
          </li>
        </ul>

        <li>
          <b>TB_FORNECEDOR_COMUNICACAO</b>
        </li>
        <ul>
          <li>
            Registros de comunicações formais realizadas com o fornecedor:
            ofício, email, carta e outros.
          </li>
        </ul>

        <li>
          <b>TB_FAQ</b>
        </li>
        <ul>
          <li>
            Entidade que armazena os dados das perguntas mais frequentes sobre
            processos relacionados à fornecedores de produtos farmacêuticos do
            DAF.
          </li>
        </ul>
      </ul>

      <b>Cardinalidades</b>
      <ul>
        <li>
          <b>TB_FORNECEDOR para TB_FORNECEDOR_REPRESENTANTE</b>
        </li>
        <ul>
          <li>
            Cada fornecedor tem um ou muitos representantes, mas cada
            representante está associado a apenas um fornecedor. Um fornecedor
            deve existir para que os representantes possam existir.
          </li>
        </ul>

        <li>
          <b>TB_FORNECEDOR para TB_FORNECEDOR_COMUNICACAO</b>
        </li>
        <ul>
          <li>
            Um fornecedor pode ter zero ou muitas comunicações, mas cada
            registro de comunicação está associado a apenas um fornecedor.
          </li>
          <li>
            É possível que existam fornecedores que não tenham registros de
            comunicação, mas não pode existir um registro de comunicação que não
            esteja vinculado a um fornecedor.
          </li>
        </ul>
      </ul>
    </>
  );
};

const RegrasDeNegocio = () => {
  return (
    <>
      <ul>
        <li>
          <b>Fornecedor</b>
        </li>
        <ul>
          <li>
            Um fornecedor não pode ser deletado caso esteja vinculado a um
            processo aquisitivo ou contrato.
          </li>
          <li>Não pode ter dois registros com o mesmo CNPJ.</li>
          <li>
            Um representante pode estar associado a mais de um fornecedor.
          </li>
        </ul>

        <li>
          <b>FAQ</b>
        </li>
        <ul>
          <li>Não podem existir FAQs com o mesmo título/assunto.</li>
        </ul>
      </ul>
    </>
  );
};

const AjudaModuloMaisOpcoes = () => {
  const [abaAtiva, setAbaAtiva] = useState<
    'definicoes' | 'regras' | 'entidades'
  >('definicoes');

  return (
    <Container>
      <Definicao>
        Módulo para{' '}
        <b>
          organizar a gestão do desenvolvimento do SisDAF, organizando os
          documentos, os itens a serem desenvolvidos, as atividades realizadas,
          versões e documentação do sistema.{' '}
        </b>
        O objetivo do módulo é concentrar, em um único local, todas as
        informações e documentos relativos ao próprio sistema.
      </Definicao>

      <AbasContainer>
        <Aba
          active={abaAtiva === 'definicoes'}
          onClick={() => setAbaAtiva('definicoes')}
        >
          Definições
        </Aba>
        {/* <Aba
          active={abaAtiva === 'entidades'}
          onClick={() => setAbaAtiva('entidades')}
        >
          Entidades
        </Aba>
        <Aba
          active={abaAtiva === 'regras'}
          onClick={() => setAbaAtiva('regras')}
        >
          Regras de Negócio
        </Aba> */}
      </AbasContainer>

      {/* Conteúdo da Aba Ativa */}
      {abaAtiva === 'definicoes' ? (
        <AbaDefinicoes />
      ) : abaAtiva === 'regras' ? (
        <RegrasDeNegocio />
      ) : (
        <Entidades />
      )}
    </Container>
  );
};

export default AjudaModuloMaisOpcoes;
